<template>
<div class="fc-chart-wrapper">
    <div class="visual">
        <h3 v-html="title" ></h3>
        <h4>
            <span v-html="subTitle" ></span>
            <!-- <a href="/fact_check_review_quick_guide.html#perc_of_factual" class="chart_more_info">
                <img alt="More Info" src="/asset/img/infobox_info_icon.png" width="15" height="15" />
            </a> -->
            <br />
            <span v-if="startDate !== '' && endDate !== ''" class="date_message">(From {{startDate}} - {{endDate}})</span>
        </h4>
        <div class="fact-checker-wrapper">

            <template v-for="(row, index) in data">
                <div v-if="row.name !== 'Think Tank' && row.name !== 'Business' && row.name !== 'University'" :key="index">

                <div v-if="hideZeroValues == false || parseInt(row.value) > 0 " class="fact-checker-bar">

                    <div class="fact-checker-icon">

                        <router-link v-if="row.link && row.image" :to="row.link" >
                            <img v-if="row.image" :src="row.image" />
                        </router-link>
                        <img v-else-if="row.image" :src="row.image" />
                        
                        <router-link v-if="row.link" :to="row.link" >
                            <div class="fact-checker-short-name" :class="{'no-image': !row.image}" >{{row.name}}</div>
                        </router-link>
                        <div v-else class="fact-checker-short-name" :class="{'no-image': !row.image}" >{{row.name}}</div>

                    </div>
                    <div class="fact-checker-the-bar-graph-wrapper">
                        <div class="fact-checker-bar-graph" :style="getPercentStyle(row)"></div>
                        <div class="in-bar-text in-bar-text-color-above">
                            {{row.value}} out of {{row.total}}
                        </div> 
                    </div>
                    <div v-if="title != 'Fact Check Outlets'" class="fact-checker-percent">
                        <div class="fact-checker-percent-text">{{getPercent(row)}}%</div>
                    </div>

                </div>

                </div>
            </template>
            
        </div>
    </div>
</div>
</template>

<script>
export default {
    name: "vertical-chart",
    props: {
        title: {
            type: String,
            required: true,
        },
        subTitle: {
            type: String,
            required: false,
            default: '',
        },
        startDate: {
            type: String,
            required: false,
            default: '',
        },
        endDate: {
            type: String,
            required: false,
            default: '',
        },
        data: {
            type: [Array, Object],
            required: true,
        },
        hideZeroValues: {
            type: Boolean,
            required: false,
            default: false,
        },
    },
    methods: {

        getPercentStyle(row){
            let value = 100 - this.getPercent(row);
            return `width: ${value}%`;
        },

        getPercent(row){

            if( parseInt(row.total) == 0 ){
                return 0;
            }

            return Math.ceil((parseInt(row.value) / parseInt(row.total)) * 100);
        },

    },
};
</script>

<style lang="scss">
.fc-chart-wrapper{
    .visual{
        .fact-checker-wrapper{
            .fact-checker-bar{
                margin-bottom: 10px;
                .fact-checker-icon{
                    margin-bottom: 0px;

                    .fact-checker-short-name{

                        &.no-image{
                            margin-top: 18px;
                            font-size: .9em;
                            text-align: left;
                        }
                    }
                }
            }
        }
    }
}
</style>